import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumb, { BreadcrumbItem } from 'view/section/Breadcrumb/Breadcrumb';
import { Conteudo } from 'view/section/Conteudo/Conteudo';
import { Botao } from 'view/component/Botao/Botao';
import { addClassificacao, updateClassificacaoById } from 'store/Classificacao/classificacaoSlice';
import ClassificacaoTable from 'view/component/ClassificacaoTable/ClassificacaoTable';
import { Classificacao } from 'model/classificacao/Classificacao';
import ClassificacaoModal from 'view/component/ClassificacaoModal/ClassificacaoModal';
import { useRestricoesFormulario } from 'service/restricao/useRestricoesFormulario/useRestricoesFormulario';
import { RestricoesClassificacaoFormulario } from 'business/formulario/RestricoesClassificacaoFormulario';
import { useHistory } from 'react-router-dom';
import { MensagensErroServidor } from 'view/component/MensagensErroServidor/MensagensErroServidor';
import { RootState } from 'store/store';


const ClassificacaoPage: React.FunctionComponent = () => {

  const initialValues =  {
    id: null,
    nome: '',
    paiId: null,
    reinoId: null,
    unidadeId: null,
  }

  const [editClassificacao, setEditClassificacao] = useState<Classificacao | null>(initialValues);
  const [isEditing, setIsEditing] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);

  const erros = useSelector((state: RootState) => state.classificacao.error);

  
  const handleAdd = () => {
    setEditClassificacao(initialValues);
    setIsEditing(false);
    setIsModalOpen(true);
  }

  const handleEdit = (classificacao: Classificacao) => {
    setEditClassificacao(classificacao);
    setIsEditing(true);
    setIsModalOpen(true);
    console.log("OnEdit: ", classificacao, editClassificacao);
  }


  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem href="/">Início</BreadcrumbItem>
        <BreadcrumbItem href="/admin">Administração</BreadcrumbItem>
        <BreadcrumbItem>Classificações</BreadcrumbItem>
      </Breadcrumb>

      <Conteudo>
        <Botao onClick={handleAdd}>Adicionar</Botao>
        <MensagensErroServidor erro={erros} />
        <ClassificacaoTable onEdit={handleEdit} />
        <ClassificacaoModal isOpen={isModalOpen} onClose={closeModal} initialValues={editClassificacao} />
      </Conteudo>
    </>
  )
}

export default ClassificacaoPage;
